import React from "react";
import { Input } from "./ui/input";
import { cn } from "../lib/utils";
import { useTrans } from "../hooks/useTrans";

const SearchInput = React.forwardRef(({ value, onChange, onClear, showClear, className, ...props }, ref) => {
    const translate = useTrans();

    return (
        <div className="relative">
            <Input
                ref={ref}
                value={value}
                onChange={onChange}
                className={cn("pr-10 font-normal", className)}
                {...props}
            />
            {showClear && value && (
                <button
                    type="button"
                    onClick={onClear}
                    className="absolute right-4 top-1/2 -translate-y-1/2 flex h-[1.4em] w-[1.4em] items-center justify-center rounded-full bg-[#bcbec0] transition-transform hover:scale-110 hover:bg-[#0b7255] cursor-pointer"
                    title={translate('Verwijder zoekopdracht')}
                >
                    <svg className="h-[50%] w-[50%] fill-white" role="img">
                        <use href="#glyph-cross"></use>
                    </svg>
                </button>
            )}
        </div>
    );
});
SearchInput.displayName = "SearchInput";

export { SearchInput };
